/*
 * @Descripttion: 画布各节点保存人群弹窗
 * @Author: yang chenglin
 * @Date: 2020-12-21 18:55:23
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-24 14:27:55
 */
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Form, Input, Button } from '@alifd/next';
import LzMsg from '@/components/common/LzMsg';
import styles from './index.module.scss';

const CreateActivity = ({
  saveCrowdData = {},
  confirm = (data) => {},
  cancel = {},
}) => {
  const [data, setData] = useState({
    ...saveCrowdData,
  });

  /**
   * 合并新旧状态
   */
  const onChange = (newData) => {
    setData({
      ...data,
      ...newData,
    });
  };
  /**
   * 提交填写信息
   */
  const commitData = () => {
    if (data.name) {
      // peopleType 31-短信人群高级选择的保存  29-画布保存
      confirm({...data, peopleType: 29});
    } else {
      LzMsg.error('请填写人群名称');
    }
  };

  return (
    <div className={styles['save-crowd-dialog']}>
      <Form className={`${styles.formDiv} ${styles.strategyDiv} canvasDialog`}>
        <Form.Item
          label="人群包名称:"
          required
          requiredMessage="请输入人群包名称"
        >
          <Input
            className="formItemWidth"
            name="strategyName"
            placeholder="请输入人群包名称"
            value={data.name}
            onChange={(name) => onChange({ name })}
            showLimitHint
            maxLength={32}
          />
          <div
            style={{ lineHeight: '20px', color: '#ff3333', textAlign: 'left' }}
          >
            人群数量： {saveCrowdData?.resultNumber || '--'}人
          </div>
        </Form.Item>
        <Form.Item label="描述:">
          <Input.TextArea
            className="formItemWidth"
            name="remark"
            placeholder="请输入描述"
            size="small"
            value={data.remark}
            onChange={(remark) => onChange({ remark })}
            showLimitHint
            maxLength={32}
          />
        </Form.Item>
      </Form>
      <div className={styles['canvas-btn-item']}>
        <Button
          type="normal"
          className={`cancel-btn ${styles.w88} ${styles.mr10}`}
          onClick={cancel}
        >
          取消
        </Button>
        <Button
          type="primary"
          className={`submit-btn ${styles.w88}`}
          onClick={commitData}
        >
          确认
        </Button>
      </div>
    </div>
  );
};
export default CreateActivity;
